import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { PostSqsMessageResponseInfo } from '@/coreInfrastructureModule/axios/generated/sqsAccessManage/api';
import { ISqsAccessManageRepository } from '@/coreInfrastructureModule/interfaces/ISqsAccessManageRepository';

/**
 * SQSにメッセージキューを追加するユースケース
 */
export class PostSqsMessageUseCase {
  /**
   * SQSにメッセージキューを追加する
   * @param repository - SQSにメッセージキューを追加する責務を負うクラス
   */
  static async execute(repository: ISqsAccessManageRepository): Promise<INetworkResult<PostSqsMessageResponseInfo, Error>> {
    try {
      const result = await repository.post();

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      console.error(error);
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラーが発生しました'),
        },
      }; // 基本的にはここには到達しないはず
    }
  }
}
